import { DeepPartial, IRCompletedWork, IRevision, IWork } from 'models';
import { IFollowups } from 'models/followups.model';

import { $api } from '../http';

const _fields = 'acf,id,author,date,meta';
const link = '/wp/v2/works';
const revisionLink = 'wp/v2/history';
const followupsLink = 'wp/v2/followup';
const search_link = '/my/v1/works';
class WorkService {
	async getAll(params?: any) {
		try {
			const res = await $api.get<IWork[]>(link, { params: { ...params, _fields } });
			return res;
		} catch (error) {
			throw error;
		}
	}

	async search({ search, page }: {search?: string, page: number}) {
		try {
			const res = await $api.get<IWork[]>(search_link, { params: { page, search, _fields } });
			return res;
		} catch (error) {
			throw error;
		}
	}

	async getOne(id: number | string, params?: any) {
		try {
			const res = await $api.get<IWork>(`${link}/${id}`, { params: { ...params, _fields } });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async getHistory(work_id: number | string) {
		try {
			const res = await $api.get<IRevision[]>(revisionLink, { params: { _fields, work_id } });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async getFollowups(customer_phone: number | string) {
		try {
			const res = await $api.get<IFollowups[]>(followupsLink, { params: { _fields, customer_phone } });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async createFollowup(data: Partial<IFollowups>) {
		try {
			const res = await $api.post<IFollowups>(followupsLink, data, { params: { _fields } });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async getByUser(id: number, params?: any) {
		try {
			const res = await $api.get<IRCompletedWork>(`/myplug/v2/users/${id}`, { params });
			return res;
		} catch (error) {
			throw error;
		}
	}

	async update(data: DeepPartial<IWork>, id?: number) {
		try {
			const res = await $api.patch<IWork>(`${link}/${id}`, data);
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async create(data: DeepPartial<IWork>) {
		try {
			const res = await $api.post<IWork>(link, data);
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	async delete(id?: number) {
		try {
			const res = await $api.delete<IWork>(`${link}/${id}`);
			return res.data;
		} catch (error) {
			throw error;
		}
	}
};

export const workService = new WorkService();